import { Instance } from 'mobx-state-tree'
import { MakeGameResultModelBase } from './MakeGameResultModel.base'

/* The TypeScript type of an instance of MakeGameResultModel */
export interface MakeGameResultModelType extends Instance<typeof MakeGameResultModel.Type> {}

/* A graphql query fragment builders for MakeGameResultModel */
export {
  selectFromMakeGameResult,
  makeGameResultModelPrimitives,
  MakeGameResultModelSelector
} from './MakeGameResultModel.base'

/**
 * MakeGameResultModel
 */
export const MakeGameResultModel = MakeGameResultModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
